import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CourseConstants } from '../../constants/course.constants';
import { PrerequisitesData } from '../../models/prerequisitesData';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { DocumentSearchResult } from '../../../document/models/documentSearchResult';
import { CourseCatalogueSearchResult } from '../../../course-catalogue/models/course-catalogue-search-result';
import { cloneDeep } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { CourseService } from '../../services/course.service';
import { DocumentCommonService } from '../../../shared/services/document-common.service';
import { Router } from '@angular/router';
import { Prerequisite } from '../../models/prerequisites';
import { AssignmentGroupSharedDataService } from '../../../../app/shared/services/assignment-group-shared-data.service';

@Component({
  selector: 'app-course-prerequisites',
  templateUrl: './course-prerequisites.component.html',
  styleUrls: ['./course-prerequisites.component.scss']
})
export class CoursePrerequisitesComponent implements OnInit{

  @Output() activateTabIndex = new EventEmitter<number>();
  @Input() coursePrerequisites ?: PrerequisitesData[];
  panelListScreen : string = CourseConstants.CoursePrerequisitesTab
  prerequisitesDataToDisplay ?: PrerequisitesData[]= [];
  prerequisiteToDelete : any;
  showDeletePrerequisiteConfirmationModal : boolean = false;
  prerequisiteDeletedMessage : string = CourseConstants.Course_Prerequisite_DeletePrerequisiteMessage;
  isAddPrerequisiteDocButtonVisible : boolean = false;
  isAddPrerequisiteCourseButtonVisible : boolean = false;
  isDocRecordSelected : boolean = false;
  isCourseRecordSelected : boolean = false;
  displayDataCollected: string[] = [];
  selectedCourses: CourseCatalogueSearchResult[] = [];
  showCheckBoxes: boolean = true;
  errorMessages : string[] = []
  showeQMSScopeValidationModal : boolean = false;
  eQMSScopeConfirmationMessage : string = "";
  prerequisitesData : any[] = []
  prerequisites : Prerequisite[] = [];
  isEditSlider : boolean = false;
  coursePrerequisitesTab : string = CourseConstants.CoursePrerequisitesTab

  isInActiveAssignmentGroupDialog:boolean=false;
  InactiveAssignmentGroupField = '';
  inactiveUserSelected:any;
  inactiveGroupsSelected:any;

    shouldLoadDocSearch: boolean = true;
  shouldLoadCourseSearch = false;
  innerActiveIndex: number = 0; // 0 = Document, 1 = Course
  @Input() sliderClosed: boolean = false;

  constructor(private coursePersistenceService : CoursePersistenceService, 
    private messageService : MessageService,
    private documentCommonService : DocumentCommonService,
    private router:Router,
    private courseService : CourseService,
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService) {

  }
   ngOnInit() {
    this.prerequisitesDataToDisplay = this.coursePrerequisites || [];
    this.coursePersistenceService.currentTabInSliderMenu$.subscribe((tabIndex) => {
      if (tabIndex === CourseConstants.Course_Prerequisites_Index) {
        // Making this Document tab as default every time parent opens Prerequisites
        this.innerActiveIndex = 0;
        this.shouldLoadDocSearch = true;
        this.shouldLoadCourseSearch = false;

        this.prepareData(); // load existing prerequisites
      }
    });

    // Subscribe to edit mode changes
    this.courseService.editCourseSlider$.subscribe((isEditSlider) => {
      this.isEditSlider = isEditSlider;
    });
  }

ngOnChanges(changes: SimpleChanges) {
  if (changes['sliderClosed'] && changes['sliderClosed'].currentValue) {
    this.resetInnerTabs();
  }
}

  onInnerTabChange(event: any) {
    this.innerActiveIndex = event.index;

    if (event.index === 0) {
      // Document tab
      this.shouldLoadDocSearch = true;
    } else if (event.index === 1) {
      // Course tab
      this.shouldLoadCourseSearch = true;
    }
  }

resetInnerTabs() {
  this.shouldLoadDocSearch = true;//setting this to true as by default we need to load this tab initially
  this.shouldLoadCourseSearch = false;
  this.innerActiveIndex = 0;
}

  openPreviousTab = () => {
    this.prepareData();
    this.activateTabIndex.emit(
        CourseConstants.Course_Create_General_Tab_Index
    );
    this.coursePersistenceService.onCustomTabChange(
      CourseConstants.Course_Create_General_Tab_Index
    );
  };

  openPrerequisites(number: string, version: number | null, prerequisiteType: number){
    if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Document){
      const url = this.router.serializeUrl(
        this.router.createUrlTree([
          '/eqms.documentDetails/' + number + ':' + version?.toString(),
        ])
      );
      window.open(url, '_blank');
    }
    else if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Course){
        var url = location.origin.concat("/training/eqms.courses/", number);
        window.open(url, "_blank");
    }
  }

  showConfirmationPopupForDeletedPrerequisites(itemToDelete : string | undefined){
    this.prerequisiteToDelete = itemToDelete;
    this.showDeletePrerequisiteConfirmationModal = true;
  }


  closeConfirmationModal = () => {
    this.showDeletePrerequisiteConfirmationModal = false;
  }

  updateSelectedData() {
    this.prerequisitesDataToDisplay?.forEach((element: PrerequisitesData, index: number) => {
      if (element.number === this.prerequisiteToDelete) {
        const indexItemToBeRemoved = index;
        this.prerequisitesDataToDisplay?.splice(indexItemToBeRemoved, 1);
      }
    });

    this.showDeletePrerequisiteConfirmationModal = false;
  }

  saveCourse(){
    this.prepareData();
    this.courseService.editCourseSlider$.subscribe((isEditCourse)=>{
      if(!isEditCourse) {
        this.coursePersistenceService.saveCourse(isEditCourse);
        
      }
      else{
        this.verifyIfCourseContainsInActiveAGForUpdate(this.coursePersistenceService.courseDetails$);
      }
    })
  }

  verifyIfCourseContainsInActiveAGForUpdate(courseDetailsInfo:any){
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(courseDetailsInfo.value,this.coursePersistenceService.validatedUsersList,
      this.coursePersistenceService.usersList
    );
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
    else {
      this.saveDocumentwithInactiveAssignmentGroup();
    }
}

  saveDocumentwithInactiveAssignmentGroup(){
    this.isInActiveAssignmentGroupDialog = false;
    this.coursePersistenceService.updateCourse(this.courseService.editCourseSlider$.getValue());
  }
  
  closeConfirmationDailog(value : boolean){    
    this.isInActiveAssignmentGroupDialog = value
  } 

  prepareData(){
    this.prerequisitesDataToDisplay?.forEach((data) =>{
      let prerequisite : Prerequisite = {
        prerequisiteNumber : data.number,
        prerequisiteType : data.prerequisiteType
      }
      let uniquePrerequisites = this.prerequisitesDataToDisplay?.filter( x =>!this.prerequisites.find(a=> a.prerequisiteNumber==x.number));
      if(uniquePrerequisites?.length){
        this.prerequisites.push(prerequisite);
      }
    })
    this.coursePersistenceService.updatePrerequisties(this.prerequisites);
  }

  courseItemsSelectedData = (courses: CourseCatalogueSearchResult[]) => {
    this.selectedCourses = [];
    this.selectedCourses = cloneDeep(courses);  
    if(this.selectedCourses.length > 0){
      this.isCourseRecordSelected = true;
    }
    else{
      this.isCourseRecordSelected = false;
    }
  }

  docPrerequisiteSelectedData(event: DocumentSearchResult[]) {
    let selectedDocumentsList: string[] = [];
    event.forEach(element => {
      selectedDocumentsList.push(element.documentNumber);
    });

    this.displayDataCollected = selectedDocumentsList;
    if(selectedDocumentsList.length > 0)
    {
      this.isDocRecordSelected = true;
    }
    else{
      this.isDocRecordSelected = false;
    }
  }

  addCourseItems(courseSearch: any) {
    const courseData = Object.assign([], this.selectedCourses);
    const modifiedCourseData = courseData.map((course: any) => ({
      number: course.courseNumber,
      title: course.name,
      ...course,
    }));

      this.getCourseSelectedItems(modifiedCourseData, courseSearch);
  }

  getCourseSelectedItems(selectedCoursesList: any, courseSearch : any) {
      const matchingDocuments: any[] = [];
      const nonMatchingDocuments: any[] = [];

      selectedCoursesList.forEach((course: any) => {
        const matchingItem = this.prerequisitesDataToDisplay?.find((item: any) => item.number === course.number);
        if (matchingItem) {
          matchingDocuments.push(matchingItem);
        } else {
          nonMatchingDocuments.push(course);
        }
      });

      if (matchingDocuments?.length) {
        const courseNumbersString = matchingDocuments.map((course: any) => ` ${course.number}`).join(', ');
        const validationMessage = CourseConstants.Course_Prerequisite_CourseLinkedMultipleTimes.replace('CourseNumbers', courseNumbersString);
        this.messageService.add({
          severity: CourseConstants.Severity_Err,
          summary: validationMessage,
          life: 2000
        });
      }
      if(nonMatchingDocuments?.length){
        const eqmsScopes = this.coursePersistenceService.courseDetails$.getValue()?.eqmsScopes;
        this.eqmsScopeValidation(nonMatchingDocuments, CourseConstants.Course_PrerequisiteType_Course, courseSearch, eqmsScopes )
      }
  }

  addDocumentItems(docSearch: any) {
    const data = Object.assign([], this.displayDataCollected);
    this.getPrerequisiteDocumentItems(data, docSearch);
  }

  getPrerequisiteDocumentItems(selecteddocumentsList: string[], docSearch : any) {
      const matchingDocuments: any[] = [];
      const nonMatchingDocuments: any[] = [];

      selecteddocumentsList.forEach((documentNumber: string) => {
        const matchingItem = this.prerequisitesDataToDisplay?.find((item: any) => item.number === documentNumber);
        if (matchingItem) {
          matchingDocuments.push(matchingItem);
        } else {
          nonMatchingDocuments.push(documentNumber);
        }
      });

      if (matchingDocuments?.length) {
        const documentNumbersString = matchingDocuments.map((document: any) => ` ${document.number}`).join(', ');
        const validationMessage = CourseConstants.Course_Prerequisite_DocumentLinkedMultipleTimes.replace('DocumentNumbers', documentNumbersString);
        this.messageService.add({
          severity: CourseConstants.Severity_Err,
          summary: validationMessage,
          life: 2000
        });
      }
      if (nonMatchingDocuments?.length) {
        this.documentCommonService
          .getEffectiveOrLatestVersionOfDocuments(nonMatchingDocuments)
          .subscribe((serviceData) => {
            const eqmsScopes = this.coursePersistenceService.courseDetails$.getValue()?.eqmsScopes;
            this.eqmsScopeValidation(serviceData, CourseConstants.Course_PrerequisiteType_Document ,docSearch, eqmsScopes)
          });
        }
  }

  eqmsScopeValidation(serviceData : any[], prerequisiteType : number, searchData: any, courseEqmsScopes ?: number[]){
    const matchingDocuments: any[] = [];
    const mismatchedDocuments: any[] = [];

    serviceData.forEach((data) => {
      const { eqmsScopes } = data;
      const hasMatch = eqmsScopes.some((scope: number) => courseEqmsScopes?.includes(scope));
      if (hasMatch) {
        matchingDocuments.push(data);
      } else {
        mismatchedDocuments.push(data);
      }
    });

    if (matchingDocuments.length) {
      this.prerequisitesData = matchingDocuments
      this.displayDocuments(prerequisiteType, searchData);
    }
    if(mismatchedDocuments.length){
      this.validateeQMSScope(mismatchedDocuments,prerequisiteType, searchData);
    }
  }

  validateeQMSScope(prerequisites: any[], prerequisiteType : number, searchData : any){
    this.showeQMSScopeValidationModal = true;
    const prerequisiteNumbers = prerequisites.map((prerequisite: any) => ` ${prerequisite.number}`).join(', ')
    if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Document){
      this.eQMSScopeConfirmationMessage= CourseConstants.Course_Prerequisite_DoumentHasNoEqmsScopeInCommon.replace('DocumentNumber', prerequisiteNumbers);
    }
    if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Course){
      this.eQMSScopeConfirmationMessage= CourseConstants.Course_Prerequisite_CourseHasNoEqmsScopeInCommon.replace('CourseNumber', prerequisiteNumbers);
    }
    this.prerequisitesData = prerequisites
  }

  closeConfirmationModalForeQMSScopeValidation(){
    this.showeQMSScopeValidationModal = false;
  }


   //Display documents in the fieldset
   displayDocuments(prerequisiteType: number, searchData : any) {
    this.showeQMSScopeValidationModal = false;
    let linkedItems = this.prerequisitesData.map(item => {
      return <PrerequisitesData>{
        title: prerequisiteType === CourseConstants.Course_PrerequisiteType_Document ? item.title : item.name,
        number: item.number,
        version: prerequisiteType === CourseConstants.Course_PrerequisiteType_Document ? item.version : null,
        prerequisiteType: prerequisiteType
      };
    });
    if (!this.prerequisitesDataToDisplay || this.prerequisitesDataToDisplay.length === 0) {
      this.prerequisitesDataToDisplay = linkedItems;
    } else {
      this.prerequisitesDataToDisplay.push(...linkedItems);
    }
    if (this.prerequisitesDataToDisplay.length > 1) {
      this.prerequisitesDataToDisplay.sort((a: any, b: any) => a.title.localeCompare(b.title));
    }
    document.querySelector('.formwrap')?.scrollTo(0, 0);
    if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Document){
      searchData.getLinkedItemsSelection();
      this.isDocRecordSelected=false;
    }
    if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Course){
      searchData.getCourseSelection();
      this.isCourseRecordSelected=false;
    }

  }

  openNextTab = () => {
    this.prepareData();
    this.activateTabIndex.emit(
      CourseConstants.Course_Create_Training_Material_Tab_Index
    );
    this.coursePersistenceService.onCustomTabChange(
      CourseConstants.Course_Create_Training_Material_Tab_Index
    );
  }
}
